import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
let { TABLE_SELECTED_COLOR, TABLE_TEXT_COLOR, MODAL_TEXT_COLOR } = constants;

let styles = {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    height: '100%',
    width: '100vw',
    backgroundColor: TABLE_SELECTED_COLOR,
    color: TABLE_TEXT_COLOR
  },
  map: {
    height: 'calc(100% - 30px)'
  },
  date: {
    color: MODAL_TEXT_COLOR
  },
  hide: {
    display: 'none'
  },
  show: {
    display: 'block'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/historymap/HistoryMap.styles.js